module.exports = __webpack_public_path__ + "img/gitlab.f1c541cc.svg";